import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const quickShareTemplate = htmlE`
  <div class="is-flex is-flex-direction-column gap-3">
        ${({
          shareWindowNoUserInfoAfterShare,
          shareUsernames,
          username,
          password,
        }) => {
          if (!shareWindowNoUserInfoAfterShare && !shareUsernames) {
            return `
            <div>
              <label class="text-sm has-text-weight-semibold" data-i18n-key="username">username</label>
              <span> : </span>
              <span>${utils.textEncode(username || "")}</span>
            </div>

            <div>
                <label class="text-sm has-text-weight-semibold" data-i18n-key="password">password</label>
                <span> : </span>
                <span>${utils.textEncode(password || "")}</span>
            </div>
        `;
          }
          return ``;
        }}

        ${({ hideShareResultLink, url, shareUsernames }) => {
          if (!hideShareResultLink && !shareUsernames) {
            return `
            <div class="word-break-all">
              <label class="text-sm has-text-weight-semibold" data-i18n-key="link">link</label>
              <span> : </span>
              <span>${utils.textEncode(url || "")}</span>
            </div>`;
          }
          return ``;
        }}

        ${({ shareUsernames }) => {
          if (shareUsernames) {
            return `
          <div>
            <p class="text-primaryMain">The following users have now been granted access to the shared items.</p>
            <p class="text-primaryMain mt-2">${utils.textEncode(
              shareUsernames
            )}</p>
          </div>
      `;
          }
        }}
    </div>`;

const errorResponseTemplate = htmlE`
${({ errorMessage }) => {
  return `<p class="text-error text-sm whitespace-preline">${utils.textEncode(
    errorMessage || ""
  )}</p>`;
}}
`;

export { quickShareTemplate, errorResponseTemplate };
